import type { IBotNetworkInterface } from '../types/bot_interface';
import type { ICTMOptions } from '../types/network';

import { KnowledgeBot } from '../core/knowledge_bot';

import { NetworkNone } from '../adapters/network_none';
import { MessagingFacade } from '../facades/messaging_facade';

import io from '@eab-pip/pi-io';

/**
 * manage network connections
 */
export class NetworkServant {
  /**
   * based on the uri in the `botInterface` we generate an appropriate network adapter
   */
  static createNetwork(bot: KnowledgeBot, botInterface: IBotNetworkInterface, messagingFacade: MessagingFacade) {
    const { uri } = botInterface;
    const networkAdapters = [...bot.customAdapters, ...bot.adapters];
    const networkAdapter = networkAdapters.find((adapter) => adapter.isOf(uri));

    if (networkAdapter) {
      return new networkAdapter(botInterface, messagingFacade);
    } else {
      return this.defaultNetwork();
    }
  }

  /**
   * @returns an empty network connection
   */
  static defaultNetwork() {
    return new NetworkNone();
  }

  static getLegalNoticeUri(uri: string): Promise<unknown> {
    return io.create('api').include('api/hosting').invoke(uri, {
      method: 'GET'
    });
  }

  static getLegalNoticeCTM(opts: ICTMOptions): Promise<unknown> {
    return (
      io
        .create('api')
        .include('api/hosting')
        .options({
          authorization: {
            type: 'ctm'
          },
          servers: {
            ctm: {
              endpoint_uri: `${opts.endpoint_uri}`,
              endpoint_token: `${opts.endpoint_token}`,
              endpoint_uri_split_string: '?'
            } as any
          }
        })
        .intercept(io.fn.api.request.ctm)
        // ctm will decide the URI
        //
        .invoke('', {
          method: 'GET'
        })
    );
  }
}
